import React, { useState } from 'react'
import { CheckIcon } from '@heroicons/react/outline'
import firebase from 'firebase/app';
import {loadStripe} from '@stripe/stripe-js';
import { Spinner } from '@blueprintjs/core';


function TeamFourFiftyAnnual({auth, subscriptions}) {

    const [showSpinner, setShowSpinner] = useState(false)

    const handleSubmit = async() =>{
        var db = firebase.firestore();
        const stripe = await loadStripe('pk_live_51IQM49DGIrW588V8peopeSILQL0Dh4Bzpv9jSadT1UvsP01cyG9UbSCFqoWMplVSbl1TE6P7pcwSrLTuGKrUTNhO00ptV0a3vv');
        setShowSpinner(true)

        var docRef =
            await db.collection('customers')
            .doc(auth.uid)
            .collection('checkout_sessions')
            .add({
              price: 'price_1JDWxgDGIrW588V8Jp83MMJQ',
              success_url: window.location.origin,
              cancel_url: window.location.origin,
              metadata: {
                tokens: 30000,
                tokensAdded: 'no'
              },
              IdempotencyKey: "XBKifMkKaHzdvSnm",
            })
    
        docRef.onSnapshot((snap) =>{
            const {error, sessionId } = snap.data();
            if (error) {
              alert(`An error occured: ${error.message}`);
            }
            if ( sessionId ) stripe.redirectToCheckout({ sessionId }); 
            console.log(snap.data())
            console.log(sessionId)
          })
        }


    return (
        <div className="bg-white shadow-md p-4 rounded-md flex">
        <div>
            <p className="mt-2">
                <span className="text-2xl font-bold text-gray-700">Pro Plan Includes</span>
            </p>
            <div className='flex my-4'>
                <div>
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/><b>2,500 Messages Monthly</b></p>
                    <p className='flex my-4'><CheckIcon className="text-green-400 h-5 mr-2"/> Unlimited Team Seats</p>
                </div>
                <div className="ml-8">
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/> Unlimited Saved Messages</p>
                    <p className='flex my-4'><CheckIcon className="text-green-400 h-5 mr-2"/> 24/7 Boundie Hunter Support</p>
                </div>
                <div className="ml-8">
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/> Exclusive Access to New Releases</p>
                    <p className='flex my-4'><CheckIcon className="text-green-400 h-5 mr-2"/> Rollover on Tokens</p>
                </div>
                <div className="ml-8">
                    <p className='flex'><CheckIcon className="text-green-400 h-5 mr-2"/> Unlimited Prospect Searches</p>
                    {/* <p className='flex my-2'><CheckIcon className="text-green-400 h-5 mr-2"/> Rollover on Tokens</p> */}
                </div>
            </div>
        </div>
        <div className="ml-auto mr-2 mt-2">
            <div>
                <p>
                    <span className="text-3xl">$</span>
                    <span className="text-4xl">450</span>
                    <span className="text-lg">/month</span>
                </p>
                <p className="mt-1">
                    <span className="text-xs text-gray-600">billed annually</span>
                </p>
                <p className="mt-1">
                    <button className="text-sm text-white cursor-default focus:outline-none font-semibold px-3 py-1 bg-red-500 rounded-lg">20% Off Monthly!</button>
                </p>
                {subscriptions?.length < 1 ?
                <button
                className="px-4 py-1 w-full rounded-md bg-green-500 text-white hover:bg-green-700 font-semibold mt-3"
                onClick={() => handleSubmit()}
                >
                    Get Started!
                </button>
                :
                null
                }
                {showSpinner ?
                    <div
                    style={{
                    marginTop: 10
                    }}
                    >
                    <Spinner /> 
                    <br></br>
                    Sending to Stripe for Payment
                    </div>   
                : null}
            </div>
        </div>
    </div>
    )
}

export default TeamFourFiftyAnnual
